import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appDataActions from '../../../../actions/appDataActions';
import * as trackingDataActions from '../../../../actions/trackingDataActions';
import * as dialogPopupActions from '../../../../actions/dialogPopupActions';
import * as appHelper from '../../../../helpers/appHelper';
import * as componentConstants from '../../../../constants/componentConstants';
import * as objectConstants from '../../../../constants/objectConstants';

class OrderingMatchingOptionReview extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: props.lang,
            option: props.option,
            asset_id: props.asset_id,
            responseData: props.responseData,
            showUserResponses:props.showUserResponses,
            locale: appHelper.getLocalData(props.option),
            id: `${props.asset_id}_${props.option.option_id}`,
            ref: `ref_option_${props.option.option_id}`,
            labelRef: `ref_option_label-${props.option.option_id}`,
            labelWidth: props.labelWidth,
            longestOption: props.longestOption,
            checkLongestOption: false,
        };
        this.getDisabledState = this.getDisabledState.bind(this);
        this.getOptionClass = this.getOptionClass.bind(this);
        this.getScreenReaderOptionClass = this.getScreenReaderOptionClass.bind(this);
        this.getOptionLabel = this.getOptionLabel.bind(this);
        this.getOrderingOptionLabel = this.getOrderingOptionLabel.bind(this);
        this.getMatchingOptionLabel = this.getMatchingOptionLabel.bind(this);
        this.getOptionAnswerLabel = this.getOptionAnswerLabel.bind(this);
        this.getOrderingOptionAnswerLabel = this.getOrderingOptionAnswerLabel.bind(this);
        this.getMatchingOptionAnswerLabel = this.getMatchingOptionAnswerLabel.bind(this);
        this.onOptionMounted = this.onOptionMounted.bind(this);
        this.setLabelWidth = this.setLabelWidth.bind(this);
    }

    componentDidMount() {
        this.onOptionMounted();

    }
    componentWillReceiveProps(nextProps) {
        if(this.state.responseData !== nextProps.responseData){
            this.setState({responseData: Object.assign({},nextProps.responseData)});
        }

        if(this.state.option !== nextProps.option){
            this.setState({option: Object.assign({},nextProps.option)});
        }

        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.option)
            });
        }

        if(this.state.showCorrectResponseControls !== nextProps.showCorrectResponseControls){
            this.setState({showCorrectResponseControls: nextProps.showCorrectResponseControls});
        }

        if(this.state.showUserResponses !== nextProps.showUserResponses){
            this.setState({showUserResponses: nextProps.showUserResponses});
        }

        if(this.state.labelWidth !== nextProps.labelWidth){
            this.setState({labelWidth: nextProps.labelWidth});
        }

        if(this.state.longestOption !== nextProps.longestOption){
            this.setState({longestOption: Object.assign({},nextProps.longestOption),checkLongestOption: true});
        }

    }

    componentDidUpdate() {
        if(this.state.checkLongestOption) {
            this.onOptionMounted();
        }
    }

    getOptionClass() {
        let className = "answered disabled ";

        if(this.state.showUserResponses){
            if(this.state.option.is_correct || this.props.scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE){
                className += ` ${this.state.option.result}`;
            }else if(!this.state.option.is_correct){
                className += ` poor`;
            }
        } else{
            className += ` ${this.state.option.result}`;
        }

        return className;
    }

    getScreenReaderOptionClass() {
        let checkedIndex = appHelper.getArrayObjectIndexByKey(this.state.responseData.checkedOptions,"option_id", this.state.option.option_id);
        if(appHelper.isDefined(this.state.responseData.outcome.result) && checkedIndex > -1) {
            return appHelper.getOptionResultString(this.state.option.result,false);
        }
    }

    getDisabledState() {
        return null;
    }

    getOptionLabel() {
        if(this.props.asset_type_code === componentConstants.ORDERING){
            return this.getOrderingOptionLabel();
        }else if(this.props.asset_type_code === componentConstants.MATCHING){
            return this.getMatchingOptionLabel();
        }

    }
    getOrderingOptionLabel(){
        return this.state.option.display_order.toString();
    }

    getMatchingOptionLabel(){
        return appHelper.getLocalData(this.state.option).option;
    }

    getOptionAnswerLabel() {
        if(this.props.asset_type_code === componentConstants.ORDERING){
            return this.getOrderingOptionAnswerLabel();
        }else if(this.props.asset_type_code === componentConstants.MATCHING){
            return this.getMatchingOptionAnswerLabel();
        }

    }
    getOrderingOptionAnswerLabel(){
        let userResponse = appHelper.getLocalData(this.state.option.selected_option).option;
        let correctResponse = appHelper.getLocalData(this.state.option).option;
        if(this.state.showCorrectResponseControls){
            return this.state.showUserResponses ? userResponse : correctResponse;
        }else{
            return userResponse;
        }
    }

    getMatchingOptionAnswerLabel(){
        let userResponse = appHelper.getLocalData(this.state.option.selected_option).option_match;
        let correctResponse = appHelper.getLocalData(this.state.option).option_match;
        if(this.state.showCorrectResponseControls){
            return this.state.showUserResponses ? userResponse : correctResponse;
        }else{
            return userResponse;
        }
    }

    onOptionMounted(){
        this.setState({checkLongestOption: false});
        let labelRef =  this.refs[this.state.labelRef];
        //console.log(`is longestOptions`,  this.state.longestOption.option_id === this.state.option.option_id, this.state.longestOption.option_id , this.state.option.option_id, labelRef.offsetWidth);
        let labelWidth = appHelper.isDefined(labelRef) && this.state.longestOption.option_id === this.state.option.option_id ? labelRef.offsetWidth : 0;
        //console.log(`labelWidth`,labelWidth);
        this.props.setLabelWidth(labelWidth);
    }

    setLabelWidth(){
        //console.log(`setLabelWidth`, this.state.labelWidth);
        if(this.state.labelWidth > 0){
            return {
                width: `${this.state.labelWidth}px`,
            };
        }
    }

    render() {
        return (
            <div className={`ordering-option ${this.getOptionClass()}`} ref={this.state.ref}>
                <div className={`option-label`} dangerouslySetInnerHTML={{__html: this.getOptionLabel()}} ref={this.state.labelRef} style={this.setLabelWidth()}/>
                <div className="option-answer" dangerouslySetInnerHTML={{__html: this.getOptionAnswerLabel()}}/>
            </div>
        );
    }
}

OrderingMatchingOptionReview.propTypes = {
    asset_type_code: PropTypes.string.isRequired,
    option: PropTypes.object.isRequired,
    asset_id:PropTypes.number.isRequired,
    responseData: PropTypes.object.isRequired,
    scoring_type: PropTypes.string.isRequired,
    showCorrectResponseControls:PropTypes.bool,
    showUserResponses:PropTypes.bool,
    setLabelWidth:PropTypes.func,
    labelWidth:PropTypes.number,
    longestOption: PropTypes.object,
    contentData: PropTypes.object,
    trackingData: PropTypes.object,
    userData: PropTypes.object,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object
};

OrderingMatchingOptionReview.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        contentData: state.contentData,
        trackingData: state.trackingData,
        userData: state.userData

    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderingMatchingOptionReview);



/** WEBPACK FOOTER **
 ** ./src/components/objects/multipleChoice/orderingMatching/OrderingMatchingOptionReview.js
 **/